import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './config';
import { getBrowserLanguage } from './detectLanguage';
import en from './locales/en';
import ptBR from './locales/pt-BR';
/**
 * Inicializacao central do i18next.
 *
 * - Namespace unico ('translation'): mantem o consumo simples (useTranslation()).
 * - Deteccao do idioma centralizada em getBrowserLanguage() (NAO usamos
 *   LanguageDetector, para que navigator.language fique isolado na camada i18n).
 * - fallbackLng 'en': chaves ausentes em pt-BR caem para o ingles sem quebrar.
 * - useSuspense: false: os recursos sao inline/sincronos, entao evitamos exigir
 *   um <Suspense> no topo da arvore.
 */
export var resources = {
    en: { translation: en },
    'pt-BR': { translation: ptBR },
};
void i18n.use(initReactI18next).init({
    resources: resources,
    lng: getBrowserLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: 'translation',
    ns: ['translation'],
    returnNull: false,
    interpolation: {
        // React ja faz o escape de valores; desligamos o escape do i18next.
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
});
export default i18n;
